import { ICustomInspectionTypeSettings } from '../../ICustomInspectionTypeSettings';
import { rovLabelScoreToColorCode } from './rovLabelScoreToColorCode';

const translation = {
    en: {
        rovLabel: {
            rovLabel: 'ROV label',
            label: 'Label',
            rovLabelResult: 'Results',
        },
        inspectionStandard: {
            rovLabel: 'ROV label',
        },
    },
    nl: {
        rovLabel: {
            rovLabel: 'ROV label',
            label: 'Label',
            rovLabelResult: 'Uitkomsten',
        },
        inspectionStandard: {
            rovLabel: 'ROV label',
        },
    },
};

export function conditionScoreToScore(conditionScore?: number | null | string) {
    if (conditionScore === undefined || conditionScore === null) {
        return null;
    }
    switch (conditionScore.toString()) {
        case '1':
            return 'A';
        case '2':
            return 'B';
        case '3':
            return 'C';
        case '4':
            return 'D';
        case '5':
            return 'E';
        case '6':
            return 'F';
        case '7':
            return 'G';
        default:
            return null;
    }
}

export function conditionScoreToColorCode(conditionScore?: number | null | string) {
    const score = conditionScoreToScore(conditionScore);
    return rovLabelScoreToColorCode(score);
}

export const rovLabelSettings: ICustomInspectionTypeSettings = {
    inspectionStandardType: 'rovLabel',
    translation,
    conditionScoreToScore,
    conditionScoreToColorCode,
};
